import { render, staticRenderFns } from "./Voices.vue?vue&type=template&id=14a75799&scoped=true"
import script from "./Voices.vue?vue&type=script&lang=js"
export * from "./Voices.vue?vue&type=script&lang=js"
import style0 from "./Voices.vue?vue&type=style&index=0&id=14a75799&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a75799",
  null
  
)

export default component.exports